export default __webpack_public_path__ + "static/media/washing-machine.e29c399b.svg";